// extracted by mini-css-extract-plugin
export default {"ellipsis":"CardImportItem_ellipsis__eqRSI","imageWrapper":"CardImportItem_imageWrapper__K0Ury","bundleCounter":"CardImportItem_bundleCounter__V2sXH"};